import { render, staticRenderFns } from "./optimizeSetting.vue?vue&type=template&id=5c51cafd&scoped=true&"
import script from "./optimizeSetting.vue?vue&type=script&lang=js&"
export * from "./optimizeSetting.vue?vue&type=script&lang=js&"
import style0 from "./optimizeSetting.vue?vue&type=style&index=0&id=5c51cafd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c51cafd",
  null
  
)

export default component.exports